<template>
<div class="m-4" id="policy">
</div>
</template>

<script>
export default {
    name: 'policy',
    components: {
    },
    data: () =>({
        faqData: '',
        privacyData: '',
        slaData: ''
    }),
    computed: {
    },
    methods: {
    },
    mounted() {
         let docType = this.$route.query.type
          if(docType == 'sla'){
          this.$store.dispatch('ACTION_GET_STATIC_PAGE', {directory: 'documents', document_type: 'sla'}).then(res => {
            let slaHtml  = atob(res)
            var policyDiv = document.createElement('div'); // is a node
        policyDiv.innerHTML = slaHtml.toString();
        document.getElementById('policy').appendChild(policyDiv);
        })
        }
      else if(docType == 'msa') {
      this.$store.dispatch('ACTION_GET_STATIC_PAGE', {directory: 'documents', document_type: 'eula'}).then(res => {
          this.slaData = atob(res)
          var policyDiv = document.createElement('div'); // is a node
        policyDiv.innerHTML = this.slaData.toString();
        document.getElementById('policy').appendChild(policyDiv);
      })
      }
      else if (docType == 'privacy') {
        this.$store.dispatch('ACTION_GET_STATIC_PAGE', {directory: 'documents', document_type: 'privacyPolicy'}).then(res => {
            this.privacyData = atob(res)
            console.log(this.privacyData)
            var policyDiv = document.createElement('div'); // is a node
            policyDiv.innerHTML = this.privacyData.toString();
            document.getElementById('policy').appendChild(policyDiv);
        })
      }
    },
  created () {
     
      
  }
}
</script>